export class HistorySearchParameters {
    pageNumber: number = 0;
    id: number = 0;
    historyTypeID: number = 0;
    supplierID: number = 0;
}